/* tslint:disable */
/* eslint-disable */

/**
 * 805290002 = Ausschreibungabgelaufen (Ausschreibung abgelaufen)
 * 
 * 805290003 = Mittelabruf (Mittelabruf)
 * 
 * 805290000 = inUberarbeitung (in Überarbeitung)
 * 
 * 805290001 = geschlossen (geschlossen)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAcePortalstatus {
 Ausschreibungabgelaufen = 805290002,
 Mittelabruf = 805290003,
 inUberarbeitung = 805290000,
 geschlossen = 805290001
}

marker([
    "Enum.GlobalEnumsAcePortalstatus.Ausschreibungabgelaufen",
    "Enum.GlobalEnumsAcePortalstatus.Mittelabruf",
    "Enum.GlobalEnumsAcePortalstatus.inUberarbeitung",
    "Enum.GlobalEnumsAcePortalstatus.geschlossen"
]);

export namespace GlobalEnumsAcePortalstatus
{
    class DataSets
    {
        static GlobalEnumsAcePortalstatusDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Ausschreibungabgelaufen", 805290002, "Ausschreibung abgelaufen"),
            new EnumValue("Mittelabruf", 805290003, "Mittelabruf"),
            new EnumValue("inUberarbeitung", 805290000, "in Überarbeitung"),
            new EnumValue("geschlossen", 805290001, "geschlossen"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAcePortalstatusDataSet;
    }
}
